import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { IPipelineMast } from "../../models/PipelineMast";
import { Fetch } from "../../shared/Fetch";
import { IModel } from "./RecruiterRejectedReqMast";
import { ILogin, IPermissionProps } from "../../models/Login";
import { EmptyFilter, Filter, IPipelineFilter } from "./Filter";
import { format } from "date-fns";
import { Publish } from "../requirement/Publish";
import { IModel2 } from "../requirement/sales/TableAll";
import { LifeCycle } from "./LifeCycle";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Tag } from 'primereact/tag';
import { AcceptRejectRejectionModal } from "./AcceptRejectRejectionModal";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    permissions?: IPermissionProps,
    ShowCelebration: (type: string) => void
}

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], td: [], loading: false } as { tableData: Array<IPipelineMast>, td: Array<IPipelineMast>, loading: boolean });
    const [tabData, setTabData] = useState({
        'Rejected': 0,
        // 'Backout': 0,
        'Rejected by End Client': 0,
        'Rejected by PV': 0,
        'Rejected by Sales Manager': 0,
    });
    const [rejectionCategory, setRejectionCategory] = useState<any>(null);
    const [plFilter, setPLFilter] = useState<IPipelineFilter>(EmptyFilter);
    const dt = useRef<any>(null);
    const [rejectionQuery, setRejectionQuery] = useState({ req_id: 0, submission_ID: 0, open: false, row: {} } as { req_id: number, submission_ID?: number, open: boolean, row: IPipelineMast });

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const [publish, setPublish] = useState({ singleData: {}, open: false } as IModel2);
    const hidePublishDialog = () => {
        setPublish({ singleData: {}, open: false });
    };

    useEffect(() => {
        loadTableData();
    }, [plFilter, props.reload]);

    useEffect(() => {
        if (tableData.td.length > 0) {
            const _tabData = {
                'Rejected': 0,
                'Rejected by End Client': 0,
                'Rejected by PV': 0,
                'Rejected by Sales Manager': 0,
                // 'Selected For Next Round': 0,
            }
            tableData.td.forEach(d => {
                switch (d.status_Name) {
                    case 'Rejected':
                        _tabData["Rejected"] += 1;
                        break;
                    case 'Rejected by End Client':
                        _tabData["Rejected by End Client"] += 1;
                        break;
                    case 'Rejected by PV':
                        _tabData["Rejected by PV"] += 1;
                        break;
                    case 'Rejected by Sales Manager':
                        _tabData["Rejected by Sales Manager"] += 1;
                        break;
                    // case 'Selected For Next Round':
                    //     _tabData["Selected For Next Round"] += 1;
                    //     break;
                }
            });
            setTabData(_tabData);
        }
    }, [tableData.td]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, td: tableData.td, loading: true });
        const response = await Fetch("Pipeline_Mast", "GET", null, `filter=${JSON.stringify(plFilter)}`, props.toast);
        if (response) {
            const data: Array<IPipelineMast> = await response.json();
            // setTableData({ tableData: data, td: data, loading: false });
            setTableData({
                tableData: data.map((rowData: any) => {
                    return { ...rowData, recruiter: (rowData.recruiter || "").split(',').map((ele: string) => (ele.trim().split("-")[0])).join(", ") }
                }),td: data, loading: false
            });
 
            LoadSubRejectionCategory(data);
        } else setTableData({ tableData: tableData.tableData, td: tableData.td, loading: false });
    }

    const [tLifeCycle, setTLifeCycle] = useState({ submission_ID: 0, consultant_Name: '', open: false, row: {} } as { submission_ID: number, consultant_Name: string | undefined, open: boolean, row: IPipelineMast });
    const hideTLifeCycle = () => {
        setTLifeCycle({ submission_ID: 0, consultant_Name: '', open: false, row: {} });
    }

    const rightToolbarTemplate = () => {
        return (
            props.permissions?.is_Export ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const filterTableDataFromTab = (status_Name: string) => {
        const _tableData = tableData.td.filter(t => t.status_Name === status_Name);
        setTableData({ tableData: _tableData, td: tableData.td, loading: false });
    }
    const filterSubStatusTableDataFromTab = (status_Name: string) => {
        const _tableData = tableData.td.filter(t => t.rejection_Status === status_Name);
        setTableData({ tableData: _tableData, td: tableData.td, loading: false });
    }

    const LoadSubRejectionCategory = async (datas: IPipelineMast[]) => {
        const response = await Fetch("Pipeline_Status_Mast/getSubCategoryListing", "GET", null, null, props.toast);
        if (response) {
            const data = await response.json();
            let newData: any = {
                rejected: data.filter((e: { status_ID: number; sub_Status_Name: any; }) => e.status_ID === 23),
                rejectedbyEC: data.filter((e: { status_ID: number; sub_Status_Name: any; }) => e.status_ID === 12),
                rejectedbyPV: data.filter((e: { status_ID: number; sub_Status_Name: any; }) => e.status_ID === 4),
                rejectedbySM: data.filter((e: { status_ID: number; sub_Status_Name: any; }) => e.status_ID === 3),
            };
            console.log("new Data", newData);
            // newData.rejectedCount = datas.filter((e: IPipelineMast) => e.rejection_Status === "");
            newData.rejected = newData.rejected.map((e: any) => {
                return { ...e, count: datas.filter(el => el.rejection_Status === e.sub_Status_Name).length };
            });
            newData.rejectedbyEC = newData.rejectedbyEC.map((e: any) => {
                return { ...e, count: datas.filter(el => el.rejection_Status === e.sub_Status_Name).length };
            });
            newData.rejectedbyPV = newData.rejectedbyPV.map((e: any) => {
                return { ...e, count: datas.filter(el => el.rejection_Status === e.sub_Status_Name).length };
            });
            newData.rejectedbySM = newData.rejectedbySM.map((e: any) => {
                return { ...e, count: datas.filter(el => el.rejection_Status === e.sub_Status_Name).length };
            });
            setRejectionCategory(newData);
        }
    };

    const GetShortName = (name: string) => {
        let splitName = name?.split(" ");
        let shorName = '';
        splitName.forEach(e => shorName = shorName + e?.split("")[0]);
        return shorName;
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Rejected Submissions</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left" style={{ width: '50%' }}>
            </span>
        </div>
    );

    const req_Job_Title = (rowData: IPipelineMast) => {
        return (<span onClick={() => setPublish({ singleData: { req_ID: rowData.req_ID }, open: true })}
            className="cursor-pointer text-cyan-700 underline">
            {rowData.req_Job_Title}
        </span>);
    };
    const subDate = (rowData: IPipelineMast) => {
        let date;
        if (rowData.subDate) date = format(new Date(rowData.subDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const status_Name = (rowData: IPipelineMast) => {
        return <span>{rowData.status_Name}</span>;
    };
    const sub_status_Name = (rowData: IPipelineMast) => {
        return (<span>
            {rowData?.rejection_Status}
        </span>);
    };
    const bLifeCycle = (rowData: IPipelineMast) => {
        return (
            <Button
                onClick={() => { if (rowData.submission_ID) setTLifeCycle({ submission_ID: rowData.submission_ID, consultant_Name: rowData.consultant_Name, open: true, row: rowData }) }}
                icon="pi pi-history" className="p-button-rounded p-button-secondary p-button-text" aria-label="History" />
        );
    };
    const rejectionQueryBodyTemplate = (rowData: IPipelineMast) => {
        return (rowData.status_Name === "Rejected" || rowData.status_Name === "Rejected by PV" || rowData.status_Name === "Rejected by End Client" || rowData.status_Name === "Rejected by Sales Manager") && rowData.isAccepted == null ? <Button icon="pi pi-question-circle" label="" className="p-button-rounded p-button-text" onClick={() => { if (rowData.req_ID) setRejectionQuery({ open: true, req_id: rowData.req_ID, submission_ID: rowData.submission_ID, row: rowData }) }} /> : <></>
    };
    const hideQueryDialog = () => {
        setRejectionQuery({ req_id: 0, submission_ID: 0, open: false, row: {} });
    };

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button icon="pi pi-refresh" className="p-button-rounded p-button-info mr-2" onClick={() => loadTableData()} />
            </React.Fragment>
        );
    };

    const DateFormat = loginObj?.date_Format;
    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter plFilter={plFilter} setPLFilter={(plFilter: IPipelineFilter) => setPLFilter(plFilter)} />
                </AccordionTab>
            </Accordion>
            <Accordion>
                <AccordionTab header="Rejection Status Filter">
                    <div style={{ display: 'flex', gap: '5px', marginBottom: '10px' }}>
                        <Button label={`SUB-${tableData.td.length}`} className="px-2 py-2 mx-1" style={{ width: '5rem' }} tooltip="Total Submissions" tooltipOptions={{ position: 'top' }} onClick={() => { setTableData({ tableData: tableData.td, td: tableData.td, loading: false }) }} />
                    </div>
                    <div style={{ display: 'flex', gap: '5px', marginBottom: '10px' }}>
                        <Button label={`RSM-${tabData["Rejected by Sales Manager"]}`} className="px-2 py-2 mx-1" style={{ width: '100%', borderBlockColor: 'red', backgroundColor: 'red' }} tooltip="Rejected by Sales Manager" tooltipOptions={{ position: 'top' }} onClick={() => filterTableDataFromTab("Rejected by Sales Manager")} />
                        {rejectionCategory != null && rejectionCategory.rejectedbySM.map((e: any) => <Button label={`${e.category_Code}-${e.count}`} className="px-2 py-2 mx-1" style={{ width: '100%', borderColor: "#f77777", backgroundColor: '#f77777' }} tooltip={`${e.sub_Status_Name}`} tooltipOptions={{ position: 'top' }} onClick={() => filterSubStatusTableDataFromTab(e.sub_Status_Name)} />)}
                    </div>
                    <div style={{ display: 'flex', gap: '5px', marginBottom: '10px' }}>
                        <Button label={`RPV-${tabData["Rejected by PV"]}`} className="px-2 py-2 mx-1" style={{ width: '100%', borderBlockColor: '#fa7814', backgroundColor: '#fa7814' }} tooltip="Rejected by PV" tooltipOptions={{ position: 'top' }} onClick={() => filterTableDataFromTab("Rejected by PV")} />
                        {rejectionCategory != null && rejectionCategory.rejectedbyPV.map((e: any) => <Button label={`${e.category_Code}-${e.count}`} className="px-2 py-2 mx-1" style={{ width: '100%', borderColor: "#fcb377", backgroundColor: '#fcb377' }} tooltip={`${e.sub_Status_Name}`} tooltipOptions={{ position: 'top' }} onClick={() => filterSubStatusTableDataFromTab(e.sub_Status_Name)} />)}
                    </div>
                    <div style={{ display: 'flex', gap: '5px', marginBottom: '10px' }}>
                        <Button label={`ECIR-${tabData["Rejected by End Client"]}`} className="px-2 py-2 mx-1" style={{ width: '100%', borderBlockColor: '#05a12e', backgroundColor: '#05a12e' }} tooltip="Rejected by End Client" tooltipOptions={{ position: 'top' }} onClick={() => filterTableDataFromTab("Rejected by End Client")} />
                        {rejectionCategory != null && rejectionCategory.rejectedbyEC.map((e: any) => <Button label={`${e.category_Code}-${e.count}`} className="px-2 py-2 mx-1" style={{ width: '100%', borderColor: "#4aa161", backgroundColor: '#4aa161' }} tooltip={`${e.sub_Status_Name}`} tooltipOptions={{ position: 'top' }} onClick={() => filterSubStatusTableDataFromTab(e.sub_Status_Name)} />)}
                    </div>
                    <div style={{ display: 'flex', gap: '5px', marginBottom: '10px' }}>
                        <Button label={`REJ-${tabData.Rejected}`} className="px-2 py-2 mx-1" style={{ width: '100%', borderBlockColor: '#8b1bfa', backgroundColor: '#8b1bfa' }} tooltip="Rejected" tooltipOptions={{ position: 'top' }} onClick={() => filterTableDataFromTab("Rejected")} />
                        {rejectionCategory != null && rejectionCategory.rejected.map((e: any) => <Button label={`${e.category_Code}-${e.count}`} className="px-2 py-2 mx-1" style={{ width: '100%', borderColor: "#ba77fc", backgroundColor: '#ba77fc' }} tooltip={`${e.sub_Status_Name}`} tooltipOptions={{ position: 'top' }} onClick={() => filterSubStatusTableDataFromTab(e.sub_Status_Name)} />)}
                    </div>
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData}
                emptyMessage="No Pipeline found."
                header={header}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="req_ID" header="Req.ID" sortable />
                <Column field="consultant_Name" header="Consultant Name" sortable body={(rowData) => _roles.includes(3) && (rowData.status_Name === "Rejected" || rowData.status_Name === "Rejected by PV" || rowData.status_Name === "Rejected by End Client" || rowData.status_Name === "Rejected by Sales Manager") ? <Tag severity="danger" value={rowData.consultant_Name} /> : <p>{rowData.consultant_Name}</p>} />
                <Column field="req_Job_Title" header="Job Title" sortable body={req_Job_Title} />
                <Column field="req_EndClient" header="End Client" sortable />
                <Column field="vendor_Company_Name" header="Prime Vendor" sortable />
                <Column field="subVendor" header="Sub Vendor" sortable />
                {/* <Column field="subDate" header="Sub Date" body={subDate} /> */}
                 <Column field="subDate" header="Sub Date" style={{minHeight:'100px'}} body={(rowData: any) => safeFormatDate(rowData.subDate, "dd/MM/yyyy", DateFormat)} />
                <Column field="sales_Person_Name" header="Sales Manager" sortable />
                <Column field="sales_Person_Company_Name" header="Sales Comp(Branch)" sortable />
                <Column field="recruiter" header="Recruiter" sortable />
                <Column field="recruiter_Company_Name" header="Recruiter Comp(Branch)" sortable />
                <Column field="req_CategoryName" header="Skills Category" sortable />
                <Column field="status_Name" header="Status" sortable body={status_Name} />
                <Column field="rejection_Status" header="Sub Status" sortable body={sub_status_Name} />
                <Column field="lifeCycle" header="LifeCycle" body={bLifeCycle} />
                {_roles.includes(3) && <Column body={rejectionQueryBodyTemplate} header="Rejection Query" />}
            </DataTable>
            <Publish singleData={publish.singleData} open={publish.open} hideDialog={hidePublishDialog} toast={props.toast} />
            <LifeCycle submission_ID={tLifeCycle.submission_ID} consultant_Name={tLifeCycle.consultant_Name} open={tLifeCycle.open} hideDialog={hideTLifeCycle} toast={props.toast} row={tLifeCycle.row} />
            <AcceptRejectRejectionModal hideQueryDialog={hideQueryDialog} open={rejectionQuery.open} toast={props.toast} submission_ID={rejectionQuery.submission_ID || 0} row={rejectionQuery.row || {}} loadTableData={loadTableData} />
        </>
    );
}
